"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4h15v3h3.025l3.979 5.685V18h-2.657a3.252 3.252 0 01-6.186 0h-3.905a3.251 3.251 0 01-6.186 0H1V4zm3.07 12a3.251 3.251 0 016.186 0H14V6H3v10h1.07zM16 14a3.252 3.252 0 014.347 2h.657v-2.685L17.984 9H16v5zm-8.837 1.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm10.09 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
  }))];
};

exports.default = _default;